module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"进一步了解":"More about","新产品，敬请期待":"New products, stay tuned"},"zh":{"进一步了解":"进一步了解","新产品，敬请期待":"新产品，敬请期待"}}')
  delete Component.options._Ctor
}
